import { render, staticRenderFns } from "./MessageIframe.vue?vue&type=template&id=1db430ba&"
import script from "./MessageIframe.vue?vue&type=script&lang=ts&"
export * from "./MessageIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports